module.exports = __webpack_public_path__ + "assets/discount-coupon-6b72bd.svg";